export function roundCurrency(value) {
  const num = Number(value);
  return Number.isFinite(num) ? Number(num.toFixed(2)) : 0;
}

export function sanitizeCurrencyInput(value) {
  if (value == null) return '';

  let next = String(value).replace(/[^\d.]/g, '');
  if (!next) return '';

  const firstDot = next.indexOf('.');
  if (firstDot !== -1) {
    next =
      next.slice(0, firstDot + 1) +
      next
        .slice(firstDot + 1)
        .replace(/\./g, '')
        .slice(0, 2);
  }

  if (next.startsWith('.')) {
    next = `0${next}`;
  }

  return next;
}
